import { useCallback, useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { electronicInvoicingApi } from "../../api/electronicInvoicingApi";

export default function ArubaConfigPage() {
  const { token } = useAuth() as any;
  const [form, setForm] = useState({
    environment: "DEMO",
    username: "",
    password: "",
    company: "",
    webhookUrl: `${window.location.origin}/api/webhooks/aruba/invoices`,
  });
  const [status, setStatus] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(() => {
    electronicInvoicingApi
      .getArubaStatus(token)
      .then((s) => setStatus(s))
      .catch((e) => setError(e?.message ?? "Errore status Aruba"));
  }, [token]);

  useEffect(() => {
    load();
  }, [load]);

  const onSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const s = await electronicInvoicingApi.connectAruba(token, form);
      setStatus(s);
    } catch (e: any) {
      setError(e?.message ?? "Errore salvataggio configurazione");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="container-fluid">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h3 className="mb-0">Configurazione Aruba</h3>
      </div>
      {error && <div className="alert alert-warning">{error}</div>}
      <div className="card shadow-sm">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-3">
              <label className="form-label">Ambiente</label>
              <select
                className="form-select"
                value={form.environment}
                onChange={(e) => setForm((p) => ({ ...p, environment: e.target.value }))}
              >
                <option value="DEMO">Demo</option>
                <option value="PRODUCTION">Produzione</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="form-label">Username</label>
              <input className="form-control" value={form.username} onChange={(e) => setForm((p) => ({ ...p, username: e.target.value }))} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Password</label>
              <input type="password" className="form-control" value={form.password} onChange={(e) => setForm((p) => ({ ...p, password: e.target.value }))} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Company / Account</label>
              <input className="form-control" value={form.company} onChange={(e) => setForm((p) => ({ ...p, company: e.target.value }))} />
            </div>
            <div className="col-12">
              <label className="form-label">URL callback/webhook NAT</label>
              <input className="form-control" value={form.webhookUrl} onChange={(e) => setForm((p) => ({ ...p, webhookUrl: e.target.value }))} />
            </div>
          </div>
          <div className="mt-3 d-flex gap-2">
            <button className="btn btn-primary" onClick={onSave} disabled={saving}>
              {saving ? "Salvataggio..." : "Salva configurazione"}
            </button>
            <button className="btn btn-outline-secondary" onClick={load}>Test connessione</button>
          </div>
        </div>
      </div>

      {status && (
        <div className="card shadow-sm mt-3">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-4"><strong>Stato connessione:</strong> {status.connected ? "Connesso" : "Non connesso"}</div>
              <div className="col-md-4"><strong>Ultimo sync:</strong> {status.lastSyncAt ? new Date(status.lastSyncAt).toLocaleString("it-IT") : "-"}</div>
              <div className="col-md-4"><strong>Codice destinatario Aruba:</strong> {status.destinationCode}</div>
              <div className="col-md-6"><strong>Auth URL:</strong> {status.authBaseUrl}</div>
              <div className="col-md-6"><strong>WS URL:</strong> {status.wsBaseUrl}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
